import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M2 9v2h19V9H2zm0 6h5v-2H2v2zm7 0h5v-2H9v2zm7 0h5v-2h-5v2z"
}), 'PowerInputTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/PowerInputTwoTone.js
// module id = 5582
// module chunks = 2